import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfirmationDAMComponent } from '@core/payments/pages/confirmation-dam/confirmation-dam.component';
import { ConfirmationpaymentComponent } from '@core/payments/pages/confirmationpayment/confirmationpayment.component';
import { PinPageComponent } from '@core/payments/pages/pin-page/pin-page.component';
import { UpdatecardpageComponent } from '@core/payments/pages/updatecardpage/updatecardpage.component';

const routes: Routes = [
  {
    path: 'payment',
    loadChildren: () =>
      import(`@core/payments/payments.module`).then((m) => m.PaymentsModule),
  },
  {
    path: 'summary',
    loadChildren: () =>
      import(`@core/summary-payment/summary-payment.module`).then(
        (m) => m.SummaryPaymentModule
      ),
  },
  {
    path: 'callback',
    loadChildren: () =>
      import(`@core/callbacks/callbacks.module`).then((m) => m.CallbacksModule),
  },
  {
    path: 'updateCard',
    component: UpdatecardpageComponent,
  },
  {
    path: 'confirmationpayment',
    component: ConfirmationpaymentComponent,
  },
  {
    path: 'pinpage',
    component: PinPageComponent,
  },
  {
    path: 'confirmationDAM',
    component: ConfirmationDAMComponent,
  },
  {
    path: 'card-administration',
    loadChildren: () =>
      import(`@core/card-administration/card-administration.module`).then(
        (m) => m.CardAdministrationModule
      ),
  },
  {
    path: 'messages',
    loadChildren: () =>
      import(`@core/messages/messages.module`).then((m) => m.MessagesModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
